// Copyright (c) 2026 by Audere

import { Box, Typography } from "@mui/material";

const Home = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Ficus Manager</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ marginTop: 2 }}>
        Management tools coming soon.
      </Typography>
    </Box>
  );
};

export default Home;
